<template>
    <div class="pageWrap">
        <div class="d-flex m-auto w-100 justify-content-center container-page mt-5">
            <div class="page text-center">
                <img src="/nuxt-assets/images/logo/big-pilulka.svg" alt="pilulka" />

                <template v-if="locale === 'ro'">
                    <h2 class="mt-5">Anunț important pentru toți utilizatorii loiali ai Pilulka.ro.</h2>
                    <div class="row mt-4">
                        <p class="text-dark fs-16">
                            Ne luăm rămas bun de la toți cei care ne-au fost alături pe parcursul acestei călătorii extraordinare.
                        </p>

                        <p class="text-dark fs-16">
                            Chiar dacă această frumoasă etapă a ajuns la sfârșit, vă asigurăm că angajamentul nostru față de voi nu se
                            oprește aici. Vom aici. Vom lua toate măsurile necesare pentru a vă oferi în continuare suportul de care aveți
                            nevoie în rezolvarea oricăror probleme ce pot apărea. Suntem aici pentru voi!
                        </p>

                        <p class="text-dark fs-16">
                            În acest sens, vă invităm să ne contactați prin adresa de email
                            <a href="mailto:dotazy@pilulka.cz">dotazy@pilulka.cz</a>, unde colegii noștri vă vor oferi asistență promptă și
                            eficientă în soluționarea oricăror întrebări, reclamații sau retururi.
                        </p>

                        <p class="text-dark fs-16">
                            Deși vom spune adio platformei Pilulka.ro, numele Pilulka și sloganul nostru, "O viață mai bună", vor fi duse
                            mai departe cu demnitate și dăruire de către colegii noștri din Cehia, Slovacia, Ungaria și Austria, prin
                            intermediul site-urilor:
                            <a href="https://www.pilulka.cz" target="_blank">pilulka.cz</a> și
                            <a href="https://www.pilulka.sk" target="_blank">pilulka.sk</a>.
                        </p>

                        <p class="text-dark fs-16">
                            În încheiere, vă transmitem întreaga noastră recunoștință pentru timpul petrecut împreună și vă dorim sănătate
                            și toate cele bune în viitor.
                        </p>

                        <p class="text-dark fs-16">
                            Cu respect,<br />
                            Echipa Pilulka
                        </p>
                    </div>
                </template>

                <template v-if="locale === 'at'">
                    <div class="row mt-4">
                        <p class="text-dark fs-16">
                            Wichtige Mitteilung an alle treuen Kunden von Pilulka.at., die uns auf dieser außergewöhnlichen Reise begleitet
                            haben. Aus strategischen Gründen werden wir uns mit April 2024 vom österreichischen Markt zurückziehen.
                        </p>

                        <p class="text-dark fs-16">
                            Wir dürfen Ihnen als Nachfolger für Ihre Apothekeneinkäufe mit der Vamida Versandapotheke einen unserer
                            geschätzten Mitbewerber empfehlen.
                            <a href="https://www.vamida.at/pilulka2vamida" target="_blank">www.vamida.at</a>
                        </p>

                        <p class="text-dark fs-16">
                            <strong
                                >Als Abschiedsgeschenk möchten wir Ihnen einen 15% Gutschein für Ihre erste bei der Vamida Versandapotheke
                                schenken. Gutscheincode pilulka15</strong
                            >
                        </p>

                        <p class="text-dark fs-16">
                            Für unsere neuesten Produkte, Angebote und Informationen bei Vamida hier geht es zur Newsletter Anmeldung:
                            <a href="https://www.vamida.at/pilulka2vamida" target="_blank">www.vamida.at</a>
                        </p>

                        <p class="text-dark fs-16">
                            Der letzte Tag, an dem wir Ihre auf pilulka.at aufgegebenen Bestellungen versenden, ist der 2. April 2024.
                            Sollten Sie Fragen haben oder Unterstützung bei Beschwerden oder Rücksendungen benötigen, bitten wir Sie, uns
                            ausschließlich über die E-Mail-Adresse <a href="mailto:dotazy@pilulka.cz">dotazy@pilulka.cz</a> zu kontaktieren.
                            Unsere Mitarbeiter stehen Ihnen zur Verfügung.
                        </p>

                        <p class="text-dark fs-16">
                            Zum Schluss möchten wir Ihnen unseren herzlichsten Dank für die Zeit aussprechen, die wir gemeinsam verbracht
                            haben und Ihnen Gesundheit sowie alles Gute für die Zukunft wünschen.
                        </p>

                        <p class="text-dark fs-16">
                            Mit freundlichen Grüßen,<br />
                            Ihr Pilulka-Team
                        </p>
                    </div>
                </template>

                <template v-if="locale === 'hu'">
                    <h2 class="mt-5">Fontos közlemény a Pilulka.hu minden felhasználójának!</h2>
                    <div class="row mt-4">
                        <p class="text-dark fs-16">
                            Szeretnénk elbúcsúzni mindazoktól, akik velünk voltak ezen a rendkívüli utazáson. Sajnos a Pilulka.hu működése
                            véget ér, de biztosítunk benne, hogy ügyfeleink iránt érzett elkötelezettségünk nem ért véget.<br />
                            Továbbra is elérhetsz minket és minden szükséges lépést megteszünk annak érdekében, hogy segítségedre legyünk
                            bármilyen felmerülő probléma esetén.
                        </p>

                        <p class="text-dark fs-16">
                            Amennyiben segítségre van szükséged, kérjük lépj kapcsolatba kollégáinkkal a
                            <a href="mailto:dotazy@pilulka.cz">dotazy@pilulka.cz</a> címen, ahol gyors és hatékony segítséget kaphatsz
                            bármilyen kérdéssel, panasszal vagy visszaküldéssel kapcsolatban.
                        </p>

                        <p class="text-dark fs-16">
                            Bár a Pilulka.hu oldaltól búcsút veszünk, a Pilulka nevet és az "Élj egészségesen" szlogenünket méltósággal és
                            odaadással visszük tovább Csehországban és Szlovákiában a továbbra is elérhető,
                            <a href="https://www.pilulka.cz" target="_blank">pilulka.cz</a> és
                            <a href="https://www.pilulka.sk" target="_blank">pilulka.sk</a> weboldalainkon.
                        </p>

                        <p class="text-dark fs-16">
                            Szeretnénk köszönetet mondani az együtt töltött időért és minden jót kívánunk kedves felhasználóinknak.
                        </p>

                        <p class="text-dark fs-16">
                            Tisztelettel,<br />
                            A Pilulka csapata
                        </p>
                    </div>
                </template>

                <div class="mt-4">
                    <span
                        v-for="(flag, index) in flags"
                        :key="index"
                        class="rounded-circle bg-white me-3"
                        style="width: 50px; height: 50px; display: inline-block"
                    >
                        <a :href="flag.url" target="_blank">
                            <img
                                :src="`/nuxt-assets/images/flags/${flag.code}.svg`"
                                alt="flag"
                                loading="lazy"
                                style="width: 28px; padding-top: 1em"
                            />
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const config = useRuntimeConfig()
const locale = config.public.locale
definePageMeta({
    layout: false,
})

if (locale === 'at') {
    await navigateTo('https://www.vamida.at/pilulka2vamida', { external: true })
}

const flags = ref([
    {
        code: 'cz',
        url: 'https://www.pilulka.cz',
    },
    {
        code: 'sk',
        url: 'https://www.pilulka.sk',
    },
])
</script>

<style lang="scss">
body {
    background: #f9ebe8 !important;
}
</style>
